export default __webpack_public_path__ + "static/media/Bionic-Arm-10.b026ece0.jpg";